// 用户接口
export interface User {
  id: string;
  name: string;
  phone_number: string;
  create_time: string;
  doctor?: Doctor | null;
  patient?: Patient | null;
}

// 医生接口
export interface Doctor {
  id: string;
  user_id: string;
  title: string;
  create_time: string;
  user?: User | null;
  patients?: Patient[];
}

// 患者接口
export interface Patient {
  id: string;
  user_id: string;
  gender: string;
  birth_date: string | null;
  create_time: string;
  user?: User | null;
}

// 治疗记录接口
export interface TreatmentRecord {
  id: string;
  patient_id: string;
  type_id: number;
  doctor_id: string;
  treatment_date: string;
  visibility: string;
  content: string;
  is_deleted: number;
  create_time: string;
  patient: Patient;
  doctor: Doctor;
  comments: TreatmentRecordComment[];
}

// 治疗记录评论接口
export interface TreatmentRecordComment {
  id: string;
  record_id: string;
  user_id: string;
  content: string;
  creator_name: string;
  comment_date: string;
  create_time: string;
  record: TreatmentRecord;
  user: User;
}

// 治疗可见性枚举
export enum TreatmentVisibility {
  Mutual = 'mutual',
  DoctorOnly = 'doctor_only',
}

// 预约状态枚举
export enum AppointmentStatus {
  Pending = 0,
  Confirmed = 1,
  Cancelled = 2,
  Rejected = 3
}

// 医生排班模板接口
export interface DoctorScheduleTemplate {
  id: string;
  doctor_id: string;
  schedule_location_id: string | null;
  slot_name: string;
  weekday: number;
  start_time: string;
  end_time: string;
  capacity: number;
  create_time: string;
  update_time: string;
  schedule_location?: ScheduleLocation;
}

// 医生排班接口
export interface DoctorSchedule {
  id: string;
  doctor_id: string;
  schedule_location_id: string | null;
  schedule_name: string;
  start_time: string;
  end_time: string;
  doctor_schedule_template_id: string;
  capacity_initial: number;
  capacity_left: number;
  create_time: string;
  schedule_location?: ScheduleLocation;
}

// 预约接口
export interface Appointment {
  id: string;
  patient_id: string;
  doctor_id: string;
  doctor_schedule_id: string;
  schedule_location_id: string | null;
  start_time: string;
  end_time: string;
  description: string;
  status: AppointmentStatus;
  create_time: string;
  update_time: string;
  patient: Patient;
  doctor: Doctor;
  doctor_schedule: DoctorSchedule;
  schedule_location?: ScheduleLocation;
}

// 日程地点接口
export interface ScheduleLocation {
  id: string;
  name: string;
  address: string;
  doctor_id: string;
  create_time: string;
  update_time: string;
}

// 自定义枚举类型接口
export interface CustomEnumType {
  id: string;
  doctor_id?: string | null;
  is_global: boolean;
  name: string;
  scenarios: CustomParamScenario[];
  mode: CustomEnumMode;
  is_enabled: boolean;
  create_time: string;
  update_time: string;
}

// 自定义枚举值接口
export interface CustomEnumValue {
  id: string;
  type_id: string;
  name: string;
  description: string;
  is_enabled: boolean;
  create_time: string;
  update_time: string;
}

// 自定义枚举类型场景枚举
export enum CustomParamScenario {
  Treatment = 'treatment',
  Appointment = 'appointment',
  PatientProfile = 'patient_profile'
}

// 自定义枚举类型模式枚举
export enum CustomEnumMode {
  Single = 'single',
  Multiple = 'multiple'
}

// 自定义字段接口
export interface CustomField {
  id: string;
  doctor_id?: string | null;
  is_global: boolean;
  name: string;
  hint: string;
  scenarios: CustomParamScenario[];
  is_enabled: boolean;
  is_deleted: boolean;
  create_time: string;
  update_time: string;
}